(() => {
  const get = (id) => document.getElementById(id);
  if (!get('floatInput')) return;
  let binaryVisible = false;
  const status = (message) => { get('hexStatus').textContent = message; };
  const floatFromHex = (hex) => {
    const view = new DataView(new ArrayBuffer(4));
    view.setUint32(0, parseInt(hex, 16), false);
    return view.getFloat32(0, false);
  };
  const display = (value) => Object.is(value, -0) ? '-0' : Number.isFinite(value) ? String(Number(value.toPrecision(8))) : String(value);

  function clear(source, message) {
    get(source === 'hex' ? 'floatInput' : 'hexInput').value = '';
    ['ABCD', 'DCBA', 'CDAB', 'BADC'].forEach((id) => {
      get('hex' + id).textContent = '—';
      get('val' + id).textContent = '—';
    });
    get('binaryDisplay').textContent = '—';
    status(message);
  }

  function render(hex) {
    const [a, b, c, d] = hex.match(/../g);
    const orders = { ABCD: a + b + c + d, DCBA: d + c + b + a, CDAB: c + d + a + b, BADC: b + a + d + c };
    Object.entries(orders).forEach(([id, word]) => {
      get('hex' + id).textContent = word.match(/../g).join(' ');
      get('val' + id).textContent = display(floatFromHex(word));
    });
    get('binaryDisplay').textContent = parseInt(hex, 16).toString(2).padStart(32, '0').match(/.{4}/g).join(' ');
  }

  window.updateFromFloat = () => {
    const text = get('floatInput').value.trim();
    const value = text === '' ? NaN : Number(text);
    const view = new DataView(new ArrayBuffer(4));
    view.setFloat32(0, value, false);
    const stored = view.getFloat32(0, false);
    const valid = Number.isFinite(value) && Number.isFinite(stored) && (value === 0 || stored !== 0);
    get('floatInput').setAttribute('aria-invalid', String(!valid));
    if (!valid) return clear('float', 'Enter a finite number within the float32 range.');
    const hex = view.getUint32(0, false).toString(16).toUpperCase().padStart(8, '0');
    get('hexInput').value = hex;
    get('hexInput').setAttribute('aria-invalid', 'false');
    status('');
    render(hex);
  };

  window.updateFromHex = () => {
    const text = get('hexInput').value.trim();
    const valid = /^[0-9a-f]{8}$/i.test(text);
    get('hexInput').setAttribute('aria-invalid', String(!valid));
    if (!valid) return clear('hex', 'Enter exactly 8 HEX digits (0–9, A–F). Incomplete values are not padded.');
    const hex = text.toUpperCase();
    const value = floatFromHex(hex);
    get('floatInput').value = Number.isFinite(value) ? (Object.is(value, -0) ? '-0' : String(value)) : '';
    get('floatInput').setAttribute('aria-invalid', 'false');
    status(Number.isFinite(value) ? '' : `IEEE 754 special value: ${String(value)}. This is not a finite measurement.`);
    render(hex);
  };
  window.toggleBinary = () => {
    binaryVisible = !binaryVisible;
    get('binaryBody').style.display = binaryVisible ? 'block' : 'none';
    get('binaryToggleArrow').textContent = binaryVisible ? '▾' : '▸';
    document.querySelector('.collapsible-toggle').setAttribute('aria-expanded', String(binaryVisible));
  };
  window.setDirection = (direction, button) => {
    document.querySelectorAll('.dir-btn').forEach((el) => el.classList.remove('active'));
    button.classList.add('active');
    get(direction === 'float-to-hex' ? 'floatInput' : 'hexInput').focus();
  };
  get('floatInput').value = '123.45';
  window.updateFromFloat();
})();
